<template>
<div v-if="isLoaded">
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-2" style="height: 64px;">
          <h6 class="modal-title">{{ $t('Upload File') }}</h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeUploadWindow">
            <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;"></cancel-icon></span>
          </button>
        </div>
      <div class="modal-body row p-0">
        <div class="col-md-6 h-100" style="overflow-y:auto">
          <div class="selected-thumbnail-display">
            <img :src="uploadingGif" alt="No thumbnail found" v-if="uploadedFilesList.length && selectedMediaType == null" style="height:30%;width:20%"/>
            <span v-if="selectedMediaType == null && uploadedFilesList.length == 0">{{ $t('Preview goes here') }}</span>
            <img :src="getProxyConvertedURL(imageThumbnailUrl)" alt="thumbnail" v-if="selectedMediaType =='image'" style="height:100%;"/>
            <template v-if="selectedMediaType == 'video'">
                <div class="h-100 w-100">
                    <video-player id="video" @controller="setController" :options="videoOptions" :isUploadWindow="true" style="height:100%;width:100%"/>
                </div>
            </template>
            <audio v-if="selectedMediaType == 'audio'" id="audio-player-id" class="audio-player" controls="controls" controlslist="nodownload">
                <source :src="audioUrl" type="audio/mpeg" />
            </audio>
            <button type="button" v-if="selectedMediaType == 'video'" v-on:click="captureThumbnailFromVideo()" class="btn text-light secondary-btn-style border-0" style="padding:5px;float:inline-end;position: absolute;inset-inline-end :0px;bottom: -18px;height: 20px;">{{ $t('Capture') }}</button>
          </div>

          <div class="heightSet" v-if="selectedMediaType == 'video'">
            <h6>{{ $t('Select thumbnail') }}</h6>
            <div class="thumbanils-display">
              <div class="generated-thumbails"  v-on:click="updateGeneratedThumbnail('thumbnailFromServer')" :class="{activeDiv: activeThumbnail === 'thumbnailFromServer'}">
                <img :src="getProxyConvertedURL(thumbnailFromServerUrl)" @error="replaceByDefaultImage" style="height:100%;width:100%" class="unselected-image"/>
              </div>

              <div class="generated-thumbails" v-on:click="updateGeneratedThumbnail('thumbnailFromServerTwo')" :class="{activeDiv: activeThumbnail === 'thumbnailFromServerTwo'}">
                <img :src="getProxyConvertedURL(secondThumbnailFromServerUrl)" @error="replaceByDefaultImage" style="height:100%;width:100%" class="unselected-image"/>
              </div>

              <div class="custom-thumbanil" v-on:click="activeThumbnail = 'uploadedThumbnail'" :class="{activeDiv: activeThumbnail === 'uploadedThumbnail'}">
                <img v-if="isUploadedThumbnailUrl" @error="replaceByDefaultImage" :src="getProxyConvertedURL(thumbnailUrl)" style="height:100%;width:100%" class="unselected-image"/>
                <canvas id="canvas" v-if="canvasImg" style="height:100%;width:100%" class="unselected-image"></canvas>
                <div class="d-inline-flex" v-if="!isUploadedThumbnailUrl && !canvasImg" style="padding-top: 15%;padding-inline-start: 13%;position:absolute;bottom:32%;inset-inline-end:10%">
                  <div style="padding:5px;margin-bottom:6px">
                    <svg xmlns="http://www.w3.org/2000/svg"  style="margin-inline-end:5px" width="16" height="16" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                      <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
                    </svg>
                    <span class="secondary-btn-style">{{ $t('Upload Thumbnail') }}</span></div></div>
                  <div v-if="!isUploadedThumbnailUrl && !canvasImg" style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                      <input style="height:100%;width:100%" type="file" id="img" name="img" accept="image/*" ref="file" v-on:change="uploadThumbnail($event)"/>
                  </div>
                  <div v-if="isUploadedThumbnailUrl || canvasImg" v-on:click="isChange = !isChange" style="position:absolute;top:0px;inset-inline-end:0px" class="replace-uploaded-thumbnail"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                      <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                      </svg>
                      <div v-if="isChange" class="change-thumbnail">{{ $t('Change') }}
                      <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                                      <input 
                                          style="height:100%;width:100%"
                                          type="file"
                                          id="img" name="img" accept="image/*"
                                          ref="file"
                                          v-on:change="uploadThumbnail($event)"
                                        />
                                </div>
                  </div>
                </div>              
              </div>
            </div>
          </div>
          <h6 v-if="uploadedFilesList.length" class="mt-4 upload-files-count">{{"Uploaded" + " " + completedFilesList.length +"/" + uploadedFilesList.length + " " +"file(s)"}}</h6>
          <h6 v-else-if="file_name_data.length" class="mt-4 upload-files-count">{{"Uploaded" + " " + completedFilesList.length +"/" + file_name_data.length + " " +"file(s)"}}</h6>
            <div class="upload-progress-bar pl-4">
              <div>
                <template v-if="groupedUploadList.length" >
                    <template v-for="files in groupedUploadList">
                        <div v-if="!files.groupId" class="d-flex mb-2" :key="files.fileUID" :class="{activeclass: activeRow == files.fileUID}" @click="displayThumbnailOfSelectedFile(files)">
                            <div class="file-name-with-progress-bar-wrapper" :id="files.fileUID" :file-data="files"  style="border: 1px solid #2b2b2b !important;border-radius: 4px;padding-inline-start: 19px;justify-content: space-between;">
                                <div class="file-name-wrapper">
                                    <div class="file-name-display" :title="files.fileName">{{files.fileName}}</div><div><span class="file-size-display">{{ humaniseSize(files.fileSize)}}</span><span class="file-size-display">{{"  |  " + moment.utc(files.createdTime).format("DD/MM/YYYY h:mm:ss a")}}</span></div>
                                    <div class="progress-bar-wrapper" v-if="files.status == 'INPROGRESS'">
                                        <div class="progress-percentage-display">{{Math.round(files.uploadPercentage) + "%"}}</div>
                                        <div class="progress">
                                                    <div class="progress-bar" role="progressbar" :style="{width:files.uploadPercentage + '%'}" :aria-valuenow="files.uploadPercentage" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <div class="progress-speed-display">
                                            {{files.bandwidth.bandwidth}} {{files.bandwidth.unit}}
                                        </div>    
                                    </div>
                                </div>
                                <div style="display: inline-flex;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" v-if="files.status == 'COMPLETED'" fill="green" class="bi bi-check-circle-fill mt-1" viewBox="0 0 16 16">
                                    <title>{{ $t('COMPLETED') }}</title>
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#b43131" v-if="files.status == 'FAILED'" class="bi bi-exclamation-circle-fill mt-1" viewBox="0 0 16 16">
                                    <title>{{ $t('FAILED') }}</title>
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#dd8518" v-if="files.status == 'INITIALIZING'" class="bi bi-clock-fill mt-1" viewBox="0 0 16 16">
                                <title>{{ $t('INITIALIZING') }}</title>
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                                </svg>
                                <div v-if="isResumableUploadEnabled && files.status == 'INPROGRESS'">
                                    <svg v-if="files.isUploadPaused" @click="files.resume()" style="margin-inline-start: 2px;margin-top: 5px;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="#9e9e9e">
                                        <path d="m 2 2.5 v 11 c 0 1.5 1.269531 1.492188 1.269531 1.492188 h 0.128907 c 0.246093 0.003906 0.488281 -0.050782 0.699218 -0.171876 l 9.796875 -5.597656 c 0.433594 -0.242187 0.65625 -0.734375 0.65625 -1.226562 c 0 -0.492188 -0.222656 -0.984375 -0.65625 -1.222656 l -9.796875 -5.597657 c -0.210937 -0.121093 -0.453125 -0.175781 -0.699218 -0.175781 h -0.128907 s -1.269531 0 -1.269531 1.5 z m 0 0"/>
                                    </svg>
                                    <svg v-else style="margin-inline-start: 2px;margin-top: 5px;" @click="files.pause()" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="-1 0 8 8" version="1.1" fill="#9e9e9e">
                                            <title>{{ $t('PAUSE') }}</title>
                                            <g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                                                <g id="Dribbble-Light-Preview" transform="translate(-227.000000, -3765.000000)">
                                                    <g id="icons" transform="translate(56.000000, 160.000000)">
                                                        <path d="M172,3605 C171.448,3605 171,3605.448 171,3606 L171,3612 C171,3612.552 171.448,3613 172,3613 C172.552,3613 173,3612.552 173,3612 L173,3606 C173,3605.448 172.552,3605 172,3605 M177,3606 L177,3612 C177,3612.552 176.552,3613 176,3613 C175.448,3613 175,3612.552 175,3612 L175,3606 C175,3605.448 175.448,3605 176,3605 C176.552,3605 177,3605.448 177,3606" id="pause-[#1006]">
                                                    </path>
                                                    </g>
                                                </g>
                                            </g>
                                    </svg>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#b43131" v-if="files.status != 'COMPLETED'" class="bi bi-x ml-2 remove-selected-file" v-on:click="discardSelectedFileFromUpload(files.fileUID,files.status)" viewBox="0 0 16 16">
                                <title>{{$t('Remove File')}}</title>
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                </div>
                            </div>
                        </div>
                        <div v-else class="d-flex mb-2" :key="files.groupId"
                            :class="{ activeclass: activeRow == files.groupId }">
                            <div class="file-name-with-progress-bar-wrapper" :id="files.fileUID" :file-data="files" style="border: 1px solid #2b2b2b !important;border-radius: 4px;padding-inline-start: 19px;justify-content: space-between;">
                                <div class="file-name-wrapper">
                                    <div class="file-name-display" :title="files.folderName">{{ files.folderName }}</div>
                                    <div>
                                        <span class="file-size-display">{{ humaniseSize(files.folderSize) }}</span>
                                        <!-- <span class="file-size-display">{{ " | " + formatDateTime(files.createdTime) }}</span> -->
                                    </div>
                                    <div class="progress-bar-wrapper mb-2" v-if="files.status == 'INPROGRESS'">
                                        <div class="progress-percentage-display">{{ Math.round(files.uploadPercentage) + "%" }}</div>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" :style="{ width: files.uploadPercentage + '%' }"
                                            :aria-valuenow="files.uploadPercentage" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <!-- <div class="progress-speed-display">
                                            {{ files.bandwidth.bandwidth }} {{ files.bandwidth.unit }}
                                        </div> -->
                                    </div>
                                    <div v-for="folderFile in files.files.filter(f => f.status === 'INPROGRESS')" class="d-flex mb-2 ml-2" :key="folderFile.fileUID" :class="{activeclass: activeRow == folderFile.fileUID}" @click="displayThumbnailOfSelectedFile(folderFile)">
                                        <div class="file-name-with-progress-bar-wrapper" style="border-top: 1px solid #282727;" :id="folderFile.fileUID" :file-data="folderFile">
                                            <div class="file-name-wrapper">
                                                <div class="file-name-display" :title="folderFile.fileName">{{folderFile.fileName}}</div><div><span class="file-size-display">{{ humaniseSize(folderFile.fileSize)}}</span><span class="file-size-display">{{"  |  " + moment.utc(folderFile.createdTime).format("DD/MM/YYYY h:mm:ss a")}}</span></div>
                                                <div class="progress-bar-wrapper">
                                                    <div class="progress-percentage-display">{{Math.round(folderFile.uploadPercentage) + "%"}}</div>
                                                    <div class="progress">
                                                                <div class="progress-bar" role="progressbar" :style="{width:folderFile.uploadPercentage + '%'}" :aria-valuenow="folderFile.uploadPercentage" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                    <div class="progress-speed-display">
                                                        {{folderFile.bandwidth.bandwidth}} {{folderFile.bandwidth.unit}}
                                                    </div>    
                                                </div>
                                            </div>
                                            <div v-if="isResumableUploadEnabled">
                                                <svg v-if="folderFile.isUploadPaused" @click="folderFile.resume()" style="margin-inline-start: 2px;margin-top: 5px;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="#9e9e9e">
                                                    <path d="m 2 2.5 v 11 c 0 1.5 1.269531 1.492188 1.269531 1.492188 h 0.128907 c 0.246093 0.003906 0.488281 -0.050782 0.699218 -0.171876 l 9.796875 -5.597656 c 0.433594 -0.242187 0.65625 -0.734375 0.65625 -1.226562 c 0 -0.492188 -0.222656 -0.984375 -0.65625 -1.222656 l -9.796875 -5.597657 c -0.210937 -0.121093 -0.453125 -0.175781 -0.699218 -0.175781 h -0.128907 s -1.269531 0 -1.269531 1.5 z m 0 0"/>
                                                </svg>
                                                <svg v-else style="margin-inline-start: 2px;margin-top: 5px;" @click="folderFile.pause()" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="-1 0 8 8" version="1.1" fill="#9e9e9e">
                                                        <title>{{ $t('PAUSE') }}</title>
                                                        <g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                                                            <g id="Dribbble-Light-Preview" transform="translate(-227.000000, -3765.000000)">
                                                                <g id="icons" transform="translate(56.000000, 160.000000)">
                                                                    <path d="M172,3605 C171.448,3605 171,3605.448 171,3606 L171,3612 C171,3612.552 171.448,3613 172,3613 C172.552,3613 173,3612.552 173,3612 L173,3606 C173,3605.448 172.552,3605 172,3605 M177,3606 L177,3612 C177,3612.552 176.552,3613 176,3613 C175.448,3613 175,3612.552 175,3612 L175,3606 C175,3605.448 175.448,3605 176,3605 C176.552,3605 177,3605.448 177,3606" id="pause-[#1006]">
                                                                </path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                </svg>
                                            </div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#b43131" class="bi bi-x ml-2 remove-selected-file" v-on:click="discardSelectedFileFromUpload(folderFile.fileUID,folderFile.status)" viewBox="0 0 16 16">
                                                <title>{{ $t('Remove File') }}</title>
                                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" v-if="files.status == 'COMPLETED'"
                                    fill="green" class="bi bi-check-circle-fill mt-1" viewBox="0 0 16 16">
                                    <title>{{ $t('COMPLETED') }}</title>
                                    <path
                                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#b43131"
                                    v-if="files.status == 'FAILED'" class="bi bi-exclamation-circle-fill mt-1" viewBox="0 0 16 16">
                                    <title>{{ $t('FAILED') }}</title>
                                    <path
                                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#dd8518"
                                    v-if="files.status == 'INITIALIZING'" class="bi bi-clock-fill mt-1" viewBox="0 0 16 16">
                                    <title>{{ $t('INITIALIZING') }}</title>
                                    <path
                                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                                </svg>
                                <div v-if="isResumableUploadEnabled && files.status == 'INPROGRESS'" style="margin: 15px;">
                                    <svg v-if="files.isUploadPaused" @click="resumeFolderUpload(files.groupId)" style="margin-inline-start: 2px;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                        <path fill="#9e9e9e" d="m 2 2.5 v 11 c 0 1.5 1.269531 1.492188 1.269531 1.492188 h 0.128907 c 0.246093 0.003906 0.488281 -0.050782 0.699218 -0.171876 l 9.796875 -5.597656 c 0.433594 -0.242187 0.65625 -0.734375 0.65625 -1.226562 c 0 -0.492188 -0.222656 -0.984375 -0.65625 -1.222656 l -9.796875 -5.597657 c -0.210937 -0.121093 -0.453125 -0.175781 -0.699218 -0.175781 h -0.128907 s -1.269531 0 -1.269531 1.5 z m 0 0"/>
                                    </svg>
                                    <svg v-else style="margin-inline-start: 2px;" @click="pauseFolderUpload(files.groupId)" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="-1 0 8 8" version="1.1">
                                        <title>{{ $t('PAUSE') }}</title>
                                        <g id="Page-1" stroke="none" stroke-width="1" fill="#9e9e9e" fill-rule="evenodd">
                                            <g id="Dribbble-Light-Preview" transform="translate(-227.000000, -3765.000000)" fill="#9e9e9e">
                                                <g id="icons" transform="translate(56.000000, 160.000000)">
                                                    <path d="M172,3605 C171.448,3605 171,3605.448 171,3606 L171,3612 C171,3612.552 171.448,3613 172,3613 C172.552,3613 173,3612.552 173,3612 L173,3606 C173,3605.448 172.552,3605 172,3605 M177,3606 L177,3612 C177,3612.552 176.552,3613 176,3613 C175.448,3613 175,3612.552 175,3612 L175,3606 C175,3605.448 175.448,3605 176,3605 C176.552,3605 177,3605.448 177,3606" id="pause-[#1006]">
                                                </path>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
              <template v-else-if="uploadedFilesList.length === 0 && file_name_data.length">
              <div class="d-flex mb-2" v-for="filename in file_name_data" :key="filename.name">
                  <div class="file-name-with-progress-bar-wrapper">
                    <div class="file-name-wrapper">
                        <div class="file-name-display" :title="filename.name">{{filename.name}}</div><div><span class="file-size-display">{{ humaniseSize(filename.size)}}</span></div>
                    </div>
                    <svg v-if="enableUpload" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#b43131" class="bi bi-exclamation-circle-fill mt-1" viewBox="0 0 16 16">
                      <title>{{ $t('FAILED') }}</title>
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#dd8518" class="bi bi-clock-fill mt-1" viewBox="0 0 16 16">
                      <title>{{ $t('INITIALIZING') }}</title>
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                    </svg>
                </div>
              </div>
              </template>
            </div>
          </div>
        </div>
        <div class="col-md-6 p-0 h-100"  style="overflow:auto">
            <ul class="metadata-dock-ul" style="margin-bottom: 0px !important;">
                <li style="width:70.5%" :title="checkIfButtonNeedsToBeDisabled?'Only single file selection is allowed, hence upload disabled':''" >
                  <div :class="checkIfButtonNeedsToBeDisabled?'disableButton':''"  class="upload-fields" style="border: 3px dotted #333333 !important;
    position: relative;
    background: #1a1e21;">
                    <div class="value-style d-inline-flex selected-thumbnail-display upload-folder-btn" style="height:80px;border:none">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                          <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
                        </svg>
                        <span class="ml-1" style="font-size:18px;">{{enableBarcodeFromStartup.enable_reference_id_workflow?'Select a file to upload':'Select files to upload'}}</span>
                    </div>
                    <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                               <input 
                                  style="height:100%;width:100%"
                                  type="file"
                                  id="file"
                                  ref="uploadFile"
                                  :multiple="uploadDetails.upload_category && uploadDetails.upload_category.catalog_type && uploadDetails.upload_category.catalog_type == 'photo_album'? true : enableBarcodeFromStartup.enable_reference_id_workflow?false:true"
                                  v-on:change="getSelectedFileDetails($event)"
                                />
                        </div>
                  </div>
                  <div v-if="!enableBarcodeFromStartup.enable_reference_id_workflow && isFolderUploadEnabled" :class="checkIfButtonNeedsToBeDisabled?'disableButton':''"  class="upload-fields" style="border: 3px dotted #333333 !important;position: relative;background: #1a1e21;margin-inline-start: 10px;">
                    <div class="value-style d-inline-flex selected-thumbnail-display upload-folder-btn" style="height:80px;border:none">
                        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                          <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
                        </svg> -->
                        <svg width="40" height="40" viewBox="15 25 170 130" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M25 45C25 39.4772 29.4772 35 35 35H80.522C83.0801 35 85.5413 36.0152 87.3591 37.8208L104.141 54.4829C105.05 55.3857 106.28 55.8932 107.559 55.8932H165C170.523 55.8932 175 60.3703 175 65.8932V135C175 140.523 170.523 145 165 145H35C29.4772 145 25 140.523 25 135V45Z" stroke="white" stroke-width="7" stroke-linejoin="round" />
                            <path d="M100 65V145" stroke="white" stroke-width="7" stroke-linecap="round" />
                            <path d="M75 90L100 65L125 90" stroke="white" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span class="ml-1" style="font-size:18px;">{{$t('Select a folder to upload')}}</span>
                    </div>
                    <div style="position: absolute;top: 1%;left:0%;opacity: 0;height:100%;width:100%">
                               <input 
                                  style="height:100%;width:100%"
                                  type="file"
                                  id="folder"
                                  ref="uploadFolder"
                                  webkitdirectory directory multiple
                                  v-on:change="getSelectedFolderDetails($event)"
                                />
                        </div>
                  </div>
                  <!-- <div class="upload-fields" v-if="jobInfoFromUploadPanel != null && jobInfoFromUploadPanel.length">
                    <div class="value-style d-inline-flex">
                        <div class="w-100" style="display:grid;min-height: 20px;overflow: auto;max-height: 80px;">
                          <span style="padding-inline-start:5px;" v-for="file in jobInfoFromUploadPanel" :key="file">{{file.fileDetails.name}} </span>
                        </div>   
                    </div>
                  </div> -->
                    <!-- <div class="d-flex">
                              <browse-icon>
                              </browse-icon>
                              
                            </div> -->
                </li>
                
                <li v-if="!globalSettingsFromStartup.configure_upload_location_from_screen ||
                           isUploadLocationEnabled">
                  <div class="upload-fields readonlyDiv">
                    <div class="key-style">{{$t('Upload path')}}</div>
                    <div class="value-style d-inline-flex">
                        <div class="w-100">
                          <span style="padding-inline-start:5px;user-select: text !important; 
                          cursor:text;">{{uploadDetails.upload_path}}</span>
                        </div>   
                    </div>
                  </div>
                  <div class="d-flex">
                  </div>
                </li>

                <li v-if="enableBarcodeFromStartup.enable_department">
                  <div class="upload-fields">
                    <div class="key-style">{{enableBarcodeFromStartup.department_alias &&  enableBarcodeFromStartup.department_alias.alias_name?enableBarcodeFromStartup.department_alias.alias_name:"Department"}}<span style="color:#858585"> *</span></div>
                    <div class="value-style d-inline-flex" style="padding-inline-start:7px;padding-top:7px">
                      <departmentsCommonComponent :isDropdown="true" @updateSelectedDepartments="updateSelectedDepartments"></departmentsCommonComponent>
                    </div>
                  </div>
                  <div class="d-flex">
                  </div>
                </li>
                
                <li v-if="enableBarcodeFromStartup.enable_reference_id_workflow">
                  <div class="upload-fields">
                    <div class="key-style"> {{enableBarcodeFromStartup.alias &&  enableBarcodeFromStartup.alias.alias_name?enableBarcodeFromStartup.alias.alias_name:"Reference ID"}} <span style="color:#858585"> *</span></div>
                    <div class="value-style d-inline-flex">
                        <div class="w-100">
                          <input
                              v-model="barcodeName"
                              type="text"
                              class="rounded input-fields text-light w-100"
                              style="margin-inline-start:5px;padding: 4px;"
                              ref="slug_name_field_in_seq_metadata"
                              :placeholder="enableBarcodeFromStartup.alias &&  enableBarcodeFromStartup.alias.alias_name?'Enter '+enableBarcodeFromStartup.alias.alias_name:'Enter Reference ID'"
                            />
                        </div>   
                    </div>
                  </div>
                  <div class="d-flex">
                  </div>
                </li>
            </ul>
                <sequence-metadata style="width:100%" :fixMinWidth="false" :screenType="selectedScreenType()" :enableMediaSlug="false" :enableOnlyFields="false" ref="sequenceMetadataModel" :defaultCategory="defaultCategory" :parentRouteName="parentRouteInfo.name" :assetsBrowseAccess="['full-control','read-write']"></sequence-metadata>
            </div>
           
      </div>
      <div class="modal-footer p-0 primary-btn-style">
        <div class="w-50">
        </div>
        <div class="w-50" style="padding-inline-start:2%;padding-top:1%">
          <button class="btn btn-outline-primary p-0 mr-2" v-on:click="fileUploadJobPost()">{{$t('Save')}}</button>
          <button class="btn btn-outline-secondary mr-2" data-dismiss="modal" v-on:click="closeUploadWindow">{{$t('Cancel')}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</template>
<script>
import Utils from "../../components.utils";
import SequenceMetadata from "./SequenceMetadata.vue"
import FileUploder from "../../plugins/fileUploader.js";
import FileUploaderToCloud from "../../plugins/fileUploadToCloud.js"
import "vue2-datepicker/index.css";
import SparkMD5 from 'spark-md5';
import cancelIcon from "../core/InlineCancelField.vue"
import {mapActions, mapGetters, mapMutations} from "vuex";
import VideoPlayer from "../core/VideoPlayer.vue";
import {NotifierConstants} from "../../components.constants.js";
import departmentsCommonComponent from "../miscellaneous/departmentsCommonComponent.vue";

export default {
  // props:["uploadDetails"],
  data() {
    return {
      uploadDetails:{},
      isLoaded:false,
      parentRouteInfo:{},
      uploadingGif: Utils.getUploadingGif(),
      file: "",
      uploadPercentage: 0,
      fileName: "",
      fileSize: -1,
      uploader: null,
      bandWidth: {bandwidth:0, unit:"KB/s"},
      time1:null,
      time3:null,
      isChange:false,
      folderFullPath:null,
    //   filesUploadResponse:null,
      uploadedFilesList:[],
      completedFilesList:[],
      selectedFilenames:"",
      selectedFilePreview:null,
      activeIndex:null,
      activeRow:null,
      selectedMediaType:null,
      mapGroupIdWithRandomColor:{},
      mapFileUIdWithFileData:{},
      generatedRandomColor:"",
      fileInfo:"",
      thumbnailUrl:null,
      isUploadedThumbnailUrl:false,
      controller:{},
      route:"",
      audioUrl:null,
      proxyOfFilesMapper:{},
      selectedFile:null,
      canvasImg:false,
      selectedConvasImage:"",
      isFirstFileSelected:false,
      activeThumbnail:"thumbnailFromServer",
      isMultipartUpload:false,
      uploadedCustomThumbnail:"",
      thumbnailFromServerUrl:"",
      secondThumbnailFromServerUrl:"",
      uploadedThumbnail:"",
      filesList:[],
      file_name_data: [],
      imageThumbnailUrl:this.uploadingGif,
      filesIdLocalPathMap:{},
      generatedThumbnailCount:0,
      // eslint-disable-next-line no-useless-escape
      specialCharactersToBeAvoided: new RegExp(/[*|\/":<>\\?]/),
      barcodeName:'',
      enableUpload: false,
      selectedDepartments:null,
      enableProjectsField:false,
      videoOptions: {
      autoplay: false,
                controls: true,
                nativeTextTracks: true,
                controlBar:{
                    'pictureInPictureToggle': false,
                },
      sources: []
      },
      folderUploadCounter: 0,
      alreadyUploadedFilesList: [],
      uploadedGroupsList: [],
      };
  },
  computed:{
    ...mapGetters("upload",["getAllJobs"]),
    ...mapGetters("users", ["getLoggedInUserPrivilege","getLoggedInUserId"]),
    checkIfButtonNeedsToBeDisabled(){
      if(this.uploadDetails.upload_category && this.uploadDetails.upload_category.catalog_type && this.uploadDetails.upload_category.catalog_type == 'photo_album'){
        return false;
      }
      if(this.enableBarcodeFromStartup.enable_reference_id_workflow){
        if(this.file_name_data.length == 1 || this.uploadedFilesList.length == 1){
          let tempArr = [];
          this.uploadedFilesList.forEach(element => {
           if(element.status == 'FAILED'){
            tempArr.push(element)
           }
          });
          if(tempArr.length > 0 && tempArr.length == this.uploadedFilesList.length){
            return false;
          }
          if(this.enableUpload){
            return false;
          }
          return true;
        }
      }
      return false
    },
    enableBarcodeFromStartup:{
      get(){
        return this.$store.state.startUpData.startUpDataDetails;
      }
    },
    defaultCategory(){
      let temp = this.uploadDetails.upload_category
      return {
        _id: temp._id,
        catalog_name: temp.catalog_name,
        parent_id_path: [
          temp.parent_id_path
          ],
        parent_path: {
          id: temp.parent_id_path,
          value: temp.parent_path
          }
      }
    },
    globalSettingsFromStartup:{
      get(){
        return this.$store.state.startUpData.startUpDataDetails;
      }
    },
    isUploadLocationEnabled(){
      return this.globalSettingsFromStartup.configure_upload_location_from_screen &&
                           this.globalSettingsFromStartup.screens.findIndex(op=>(op.name=='Upload' &&
                           op.field_id_list.includes('Upload path'))) >= 0
    },
    isResumableUploadEnabled(){
      return this.globalSettingsFromStartup.enable_resumable_uploads || false;
    },
    isFolderUploadEnabled(){
      return this.globalSettingsFromStartup.enable_folder_upload || false;
    },
    groupedUploadList() {
        const groupMap = new Map();
        const result = [];
        this.uploadedFilesList.forEach(file => {
            if (file.isFolderUpload) {
                if (!groupMap.has(file.groupId)) {
                    groupMap.set(file.groupId, {
                        groupId: file.groupId,
                        folderName: file.file?.webkitRelativePath?.split('/')[0] || '',
                        files: [],
                        uploadPercentage: 0,
                        status: file.status,
                        isUploadPaused: file.isUploadPaused
                    });
                    result.push(groupMap.get(file.groupId));
                }
                groupMap.get(file.groupId).files.push(file);
            } else {
                result.push(file);
            }
        });
        // Calculate group status/percentage
        result.forEach(group => {
            if (group.files) {
                const completed = group.files.filter(f => f.status === 'COMPLETED').length;
                group.uploadPercentage = (completed / group.files.length) * 100;
                group.status = group.files.some(f => f.status === 'INPROGRESS') ? 'INPROGRESS'
                    : group.files.some(f => f.status === 'INITIALIZING') ? 'INITIALIZING'
                    : group.files.every(f => f.status === 'COMPLETED') ? 'COMPLETED'
                    : 'FAILED';
                group.isUploadPaused = group.files.some(f => f.isUploadPaused);
                group.folderSize = group.files.reduce((acc, f) => acc + (f.fileSize || 0), 0);
            }
        });
        return result;
    },
  },
  components:{
    // "browse-icon":BrowseIcon,
    "sequence-metadata":SequenceMetadata,
    'cancel-icon':cancelIcon,
    "video-player":VideoPlayer,
    departmentsCommonComponent
  },
  watch:{
   async selectedFile(newVal, oldVal){// eslint-disable-line no-unused-vars
            if(newVal.fileInfo == undefined){
              this.selectedMediaType = null;
            }else if(newVal.fileInfo.type.startsWith("video") && this.proxyOfFilesMapper[newVal.fileUID] != undefined){
                if (this.proxyOfFilesMapper[newVal.fileUID].proxy_info.lowres_uri != this.proxyOfFilesMapper[oldVal.fileUID].proxy_info.lowres_uri){
                  this.selectedMediaType = "video";
                    this.videoOptions.sources = [{
                        src:this.proxyOfFilesMapper[newVal.fileUID].proxy_info.lowres_uri,
                        type: "video/mp4"
                    }]
                    if (  this.controller.player){
                        this.controller.restartPlayer(this.videoOptions.sources[0])
                    }
                    let storyboardList = await this.getStoryboardList( {url:this.proxyOfFilesMapper[newVal.fileUID].proxy_info.storyboard_uri});
                      if(storyboardList.length != 0){
                          // this.thumbnailFromServerUrl = `${decodeURIComponent(this.proxyOfFilesMapper[newVal.fileUID].proxy_info.storyboard_uri)}/${decodeURIComponent(storyboardList[0]["name"])}`;
                          this.secondThumbnailFromServerUrl = `${decodeURIComponent(this.proxyOfFilesMapper[newVal.fileUID].proxy_info.storyboard_uri)}/${decodeURIComponent(storyboardList[parseInt(storyboardList.length/2)]["name"])}`;
                      }
                }
              }else if(newVal.fileInfo.type.startsWith("audio") && this.proxyOfFilesMapper[newVal.fileUID] != undefined){
                  this.selectedMediaType = "audio";
                  if (this.proxyOfFilesMapper[newVal.fileUID].proxy_info.audiowaveform_uri != this.proxyOfFilesMapper[oldVal.fileUID].proxy_info.audiowaveform_uri){
                      this.audioUrl = this.proxyOfFilesMapper[newVal.fileUID].proxy_info.audiowaveform_uri
                      document.getElementById("audio-player-id").load(); 
                  }
              }else if(newVal.fileInfo.type.startsWith("image") && this.proxyOfFilesMapper[newVal.fileUID] != undefined){
                      this.selectedMediaType = "image";
                      this.imageThumbnailUrl =  Utils.convertToLoginIPDomainName(this.proxyOfFilesMapper[newVal.fileUID].proxy_info.thumbnail_uri);
              }else{
                this.selectedMediaType = null;
              } 
        }
    },
  methods: {
    ...mapMutations("websocket",["addWSEventListener","removeWSEventListener"]),
    ...mapActions("jobs", ["createNewJob"]),
    ...mapActions("files",["getFileInfoFromServer","getStoryboardList"]),
    ...mapActions("upload",["uploadFile","attachMetadataToFile","cancelUploadFile","uploadToCloud","attachCustomThumbnail", "initiateUploadBySubmittingAction","getSessionInfoFromServer","getCloudSessionInfoFromServer","createUploadSession"]),
    ...mapMutations("upload",["addToUploadList", "startUpload", "abortUpload", "handleUploadExit","setFileUploaderState","setFileUploadToCloudState","removeFailedFiles","emptyOldFiles"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapActions("categories",["getCategoryInfoFromServer"]),
    replaceByDefaultImage(e){
      e.target.onerror = null
      e.target.src = Utils.getNoThumbnailImg();
    },
    handleFolderBrowseUpdation(pathInfo){
      this.folderFullPath = pathInfo.path
    },
    setController(controller){
            this.controller = controller
    },
    closeModalCompoent(){
      if (Object.keys(this.parentRouteInfo)!=0 && Object.keys(this.parentRouteInfo).includes("name") ){
        this.$router.push({
          name: this.parentRouteInfo.name,
          params:this.parentRouteInfo.params,
          query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
        })
      }else{
        this.$router.push({
          name: "catalogs-display",
          params:{
              _id: this.uploadDetails.upload_category._id, 
              pid: this.uploadDetails.upload_category.parent_id_path[0],
              file_name: this.uploadDetails.upload_category.catalog_name,
              catalog_name: this.uploadDetails.upload_category.catalog_name,
              catalog_id:this.uploadDetails.upload_category._id,
              asset_state:this.uploadDetails.upload_category.asset_state,
              permissions:this.uploadDetails.upload_category.permissions,
              catalog_type:this.uploadDetails.upload_category.catalog_type
              }
        })
      }
    },
    closeUploadWindow(){
      if(this.uploadedFilesList && this.uploadedFilesList.length && this.uploadedGroupsList && this.uploadedGroupsList.length){
       if(confirm(
          `Are you sure you want to cancel the upload?`
        )){
          for(let i=0; i<this.uploadedFilesList.length; i++){
              let payload = {};
              payload = {file_uid:this.uploadedFilesList[i].fileUID,job_id:this.mapFileUIdWithFileData[this.uploadedFilesList[i].fileUID].job_id};
              this.abortUpload({"job_id": this.mapFileUIdWithFileData[this.uploadedFilesList[i].fileUID].job_id,"data":payload});
          }
            //Call cancelUploadFile for group_id and all group_id_0, group_id_1... until all files are cancelled for that group
            for(let j=0; j<this.uploadedGroupsList.length; j++){
                let payload = {"group_id":this.uploadedGroupsList[j]};
                this.cancelUploadFile(payload).then((data)=>{
                if (data.statusCode==200){
                    // this.$emit("close","upload","closeWindow");
                    this.closeModalCompoent()
                    this.$toast.success(data.message);
                    this.filesList = [];
                }else{
                    this.$toast.error(data.message);
                }
                });
            }
      }
      }else{
            this.closeModalCompoent();
            this.filesList = [];
      }
    },
    discardSelectedFileFromUpload(fileUid,status){
      if(status == "FAILED"){
        this.removeFailedFiles(this.mapFileUIdWithFileData[fileUid].job_id);
        this.uploadedFilesList = Object.values(this.getAllJobs);
      }else{
        if(confirm(`Are you sure you want to abort selected file?`)){
            let payload = {};
            payload = {file_uid:fileUid,job_id:this.mapFileUIdWithFileData[fileUid].job_id};
            this.abortUpload({"job_id": this.mapFileUIdWithFileData[fileUid].job_id,"data":payload});
        }else{
          return false;
      }
      }
    },
    selectedScreenType(){
      if(this.uploadDetails.upload_category && this.uploadDetails.upload_category.catalog_type && this.uploadDetails.upload_category.catalog_type == 'photo_album'){
        return "Upload Inside Photo Album"
      }else{
        return "Upload"
      }
    },
    selectedThumbnail(file){
      this.selectedFilePreview = URL.createObjectURL(file);
      this.activeIndex = file.name;
    },
    updateGeneratedThumbnail(thumbnailType){
      this.activeThumbnail = thumbnailType;
      this.customThumbnailUploadCheckboxAction(thumbnailType);
    },
    getFilenameWithUuid: function(fileName){ 
      let file_name = fileName;
      if (this.getStartUpDataFromInCache().multiple_extentions && Array.isArray(this.getStartUpDataFromInCache().multiple_extentions) && this.getStartUpDataFromInCache().multiple_extentions.length > 0) {
        // Check for multi-part extensions if the list is provided
        let matchedExtension = this.getStartUpDataFromInCache().multiple_extentions.find(ext => file_name.endsWith(ext));
        if (matchedExtension) {
          let namePart = file_name.slice(0, -matchedExtension.length); // Exclude matched extension
          return namePart + "_" + Utils.getUUID() + matchedExtension;
        }
      }

      // Default behavior for single extensions
      let lastIndexOfDot = file_name.lastIndexOf(".");
      if (lastIndexOfDot !== -1) {
        let extension = file_name.slice(lastIndexOfDot, file_name.length);
        let namePart = file_name.slice(0, lastIndexOfDot);
        return namePart + "_" + Utils.getUUID() + extension;
      }

      // If no extension is found, just add UUID to the file name
      return file_name + "_" + Utils.getUUID();
    },
    async getSelectedFileDetails(e){
      let selectedFilenames = this.$refs.uploadFile.files;
        this.activeIndex = e.target.files[0].name;
        this.selectedFilePreview = URL.createObjectURL(e.target.files[0]);
        this.file_name_data = selectedFilenames;
        for (let i = 0; i < selectedFilenames.length; i++) {
          let isValidSession = false;
          let session_response = {};
          if(this.isResumableUploadEnabled){
            session_response = await this.getSessionInfoFromServer({ params: { file_name: selectedFilenames[i].name , size: selectedFilenames[i].size, dest_dir: this.uploadDetails.upload_path } });
            if (Utils.isAcceptedStatusCode(session_response.statusCode)) {
              isValidSession = await this.isValidSessionExist(session_response,selectedFilenames[i]);
            } else {
                this.$toast.error(session_response.message);
            }
          }
          if (this.isResumableUploadEnabled && (isValidSession || session_response.job_info)) {
            const filesUploadResponse = session_response.job_info;
            this.mapFileUIdWithFileData[filesUploadResponse.data.file_uid] = filesUploadResponse;
            delete session_response.job_info;
            if (Object.keys(filesUploadResponse.data.upload_url).includes("fields")) {
              this.isMultipartUpload = true;
              let limitUploadToCloud = this.uploadToCloudThroughProvidedUrl(
                selectedFilenames[i], 
                filesUploadResponse.data.upload_url, 
                filesUploadResponse, 
                this.uploadDetails, 
                filesUploadResponse.created_datetime, 
                filesUploadResponse.data.file_name, 
                isValidSession ? session_response : null
              );
              this.addToUploadList({ "job_id": filesUploadResponse.job_id, "uploader": limitUploadToCloud });
              this.startUpload();
            } else {
                let uploader = this.handleFileUpload(
                    selectedFilenames[i], 
                    this.uploadDetails.upload_path, 
                    this.uploadDetails.upload_token, 
                    filesUploadResponse.data.session_id, 
                    filesUploadResponse.data.file_uid, 
                    filesUploadResponse.job_id, 
                    this.uploadDetails.upload_url, 
                    filesUploadResponse.created_datetime, 
                    filesUploadResponse.data.file_name, 
                    isValidSession ? session_response.uploaded_bytes : 0
                );
                this.addToUploadList({ "job_id": filesUploadResponse.job_id, "uploader": uploader });
                this.startUpload()
              }
          }
          else {
            let payload = {};
            payload.job_name = "Upload";
            payload.element_type = "file";
            payload.group_id = this.uploadDetails.group_id;
            payload.upload_token = this.uploadDetails.upload_token;
            payload.upload_url = this.uploadDetails.upload_url;
            payload.file_name = this.enableBarcodeFromStartup.enable_reference_id_workflow?selectedFilenames[i].name:this.getFilenameWithUuid(selectedFilenames[i].name);
            payload.size = selectedFilenames[i].size;
            payload.path = this.uploadDetails.upload_path;
            payload.bin_id = this.uploadDetails.binId;
            if(this.$refs.sequenceMetadataModel && this.$refs.sequenceMetadataModel.getCatalogDetails()){
              payload.catalog_id_path = this.$refs.sequenceMetadataModel.getCatalogDetails();
            }
            if(this.specialCharactersToBeAvoided.exec(selectedFilenames[i].name) != null){
              alert('File name containing any of these <>:"|/?*\\ characters are skipped');
              continue;
            }
            this.createNewJob(payload).then(async (data)=>{
              if(!Utils.isAcceptedStatusCode(data.statusCode)){
                    this.$toast.error(data.message);
                    if(this.enableBarcodeFromStartup.enable_reference_id_workflow){
                      this.enableUpload = true;
                    }
              }
              const filesUploadResponse = data;
              this.mapFileUIdWithFileData[filesUploadResponse.data.file_uid] = filesUploadResponse;
              this.mapGroupIdWithRandomColor[filesUploadResponse.group_id] = this.generatedRandomColor;
              if(!this.uploadedGroupsList.includes(filesUploadResponse.group_id)){
                this.uploadedGroupsList.push(filesUploadResponse.group_id);
              }
              // let randomColor = this.mapGroupIdWithRandomColor[this.uploadDetails.group_id];
              if (Utils.isAcceptedStatusCode(data.statusCode)){
                  this.enableUpload = false;
                  if(this.isResumableUploadEnabled){
                        let session_payload = {
                            file_name: selectedFilenames[i].name,
                            size: selectedFilenames[i].size,
                            dest_dir: this.uploadDetails.upload_path,
                            session_id: filesUploadResponse.data.session_id,
                            job_id: filesUploadResponse.job_id
                        }
                        let fileUploadSessionRes = await this.createUploadSession(session_payload);
                        if (!Utils.isAcceptedStatusCode(fileUploadSessionRes.statusCode)) {
                            this.$toast.error(fileUploadSessionRes.message);
                        }
                        console.log("Debugging: Created upload session for file "+selectedFilenames[i].name+" with response: ", fileUploadSessionRes);
                  }
                  if(Object.keys(filesUploadResponse.data.upload_url).includes("fields")){
                    this.isMultipartUpload = true;
                    let limitUploadToCloud = this.uploadToCloudThroughProvidedUrl(selectedFilenames[i],filesUploadResponse.data.upload_url,filesUploadResponse,this.uploadDetails,filesUploadResponse.created_datetime,payload.file_name);
                    this.addToUploadList({"job_id":filesUploadResponse.job_id,"uploader": limitUploadToCloud});
                    this.startUpload();
                  }else{
                    let uploader = this.handleFileUpload(selectedFilenames[i],this.uploadDetails.upload_path,this.uploadDetails.upload_token,filesUploadResponse.data.session_id,filesUploadResponse.data.file_uid,filesUploadResponse.job_id,this.uploadDetails.upload_url,filesUploadResponse.created_datetime,payload.file_name);
                    this.addToUploadList({"job_id":filesUploadResponse.job_id,"uploader": uploader});
                    this.startUpload()
                  }
              }else{
                    this.$toast.error(data.message);
                  }
              }); 
            }
        }
    },
    async getSelectedFolderDetails(e) {
      let selectedFilenames = this.$refs.uploadFolder.files;
      this.activeIndex = e.target.files[0].name;
      this.selectedFilePreview = URL.createObjectURL(e.target.files[0]);
      const parentFolderName = selectedFilenames[0].webkitRelativePath.split("/")[0];
      const folderSize = selectedFilenames.length && Array.from(selectedFilenames).reduce((acc, file) => acc + file.size, 0);
      this.file_name_data = [{
        name: parentFolderName,
        size: folderSize,
      }];
      let folder_session_response = {};
      let folderUploadSession = {};
      this.folderUploadCounter += 1;
      if(this.isResumableUploadEnabled){
        folder_session_response = await this.getSessionInfoFromServer({ params: { file_name: parentFolderName+'/', size: folderSize, dest_dir: this.uploadDetails.upload_path } });
        if (!Utils.isAcceptedStatusCode(folder_session_response.statusCode)) {
            console.error("Error while getting session info for folder upload: ", folder_session_response.message);
            folder_session_response = { is_valid_session_exists: false };
        }

        if (!this.isValidSessionExistForFolder(folder_session_response, selectedFilenames)) {
            folderUploadSession = {
                "file_name": parentFolderName+'/',
                "size": folderSize,
                "group_id": this.uploadDetails.group_id+"_"+this.folderUploadCounter,
                "dest_dir": this.uploadDetails.upload_path,
                "files": Array.from(selectedFilenames).map(file => ({
                    file_name: file.webkitRelativePath,
                    size: file.size,
                }))
            }
            let folderUploadSessionRes = await this.createUploadSession(folderUploadSession);
            if (!Utils.isAcceptedStatusCode(folderUploadSessionRes.statusCode)) {
                this.$toast.error(folderUploadSessionRes.message);
            } else {
                folderUploadSession._id = folderUploadSessionRes._id
            }
        } else {
            folderUploadSession = { "_id": folder_session_response._id, "group_id": folder_session_response.folder_info.group_id };
        }
      }
      for (let i = 0; i < selectedFilenames.length; i++) {
        console.log("Debugging: folder_session_response: ", folder_session_response);
        if(this.isResumableUploadEnabled && 'folder_info' in folder_session_response && 'uploaded_files' in folder_session_response.folder_info && folder_session_response.folder_info.uploaded_files.map(file => file.file_name).includes(selectedFilenames[i].webkitRelativePath)){
          const alreadyUploadedFile = folder_session_response.folder_info.uploaded_files.find(file => file.file_name == selectedFilenames[i].webkitRelativePath);
          this.completedFilesList.push(alreadyUploadedFile.file_uid);
          let fileInfo = {
            file: selectedFilenames[i],
            status: 'COMPLETED', 
            groupId: alreadyUploadedFile.group_id,
            isFolderUpload: true,
          }
          this.uploadedFilesList.push(fileInfo);
          this.alreadyUploadedFilesList.push(fileInfo);
          console.log("File "+selectedFilenames[i].name+" is already uploaded in the folder, hence skipping the file upload");
          continue;
        }
        let isValidSession = false;
        let session_response = {};
        if(this.isResumableUploadEnabled){
            session_response = await this.getSessionInfoFromServer({ params: { file_name: selectedFilenames[i].webkitRelativePath , size: selectedFilenames[i].size, dest_dir: this.uploadDetails.upload_path} });
            if (Utils.isAcceptedStatusCode(session_response.statusCode)) {
                isValidSession = await this.isValidSessionExist(session_response,selectedFilenames[i]);
            }
        }
        if (this.isResumableUploadEnabled && (isValidSession || session_response.job_info)) {
            let filesUploadResponse = session_response.job_info;
            this.mapFileUIdWithFileData[filesUploadResponse.data.file_uid] = filesUploadResponse;
            if(!this.uploadedGroupsList.includes(filesUploadResponse.group_id)){
                this.uploadedGroupsList.push(filesUploadResponse.group_id);
            }
            delete session_response.job_info;
            if (Object.keys(filesUploadResponse.data.upload_url).includes("fields")) {
              this.isMultipartUpload = true;
              let limitUploadToCloud = this.uploadToCloudThroughProvidedUrl(selectedFilenames[i], filesUploadResponse.data.upload_url, filesUploadResponse, this.uploadDetails, filesUploadResponse.created_datetime, filesUploadResponse.data.file_name, isValidSession ? session_response : null, folderUploadSession.group_id, true);
              this.addToUploadList({ "job_id": filesUploadResponse.job_id, "uploader": limitUploadToCloud });
              this.startUpload();
            } else {
                const relativePath = selectedFilenames[i].webkitRelativePath || "";
                const relativeDir = relativePath.includes("/")
                  ? relativePath.substring(0, relativePath.lastIndexOf("/") + 1)
                  : "";
                let uploader = this.handleFileUpload(
                  selectedFilenames[i],
                  this.uploadDetails.upload_path + "/" + relativeDir,
                  this.uploadDetails.upload_token,
                  filesUploadResponse.data.session_id,
                  filesUploadResponse.data.file_uid,
                  filesUploadResponse.job_id,
                  this.uploadDetails.upload_url + "/" + relativeDir,
                  filesUploadResponse.created_datetime,
                  filesUploadResponse.data.file_name,
                  isValidSession ? session_response.uploaded_bytes : 0,
                  filesUploadResponse.group_id,
                  true
                );
                this.addToUploadList({ "job_id": filesUploadResponse.job_id, "uploader": uploader });
                this.startUpload()
              }
        }
        else {
              let payload = {};
              payload.job_name = "Upload";
              payload.element_type = "file";
              payload.group_id = this.uploadDetails.group_id+"_"+this.folderUploadCounter;
              payload.upload_token = this.uploadDetails.upload_token;
              payload.upload_url = this.uploadDetails.upload_url;
              payload.file_name = this.enableBarcodeFromStartup.enable_reference_id_workflow?selectedFilenames[i].name:this.getFilenameWithUuid(selectedFilenames[i].name);
              payload.size = selectedFilenames[i].size;
              payload.path = this.uploadDetails.upload_path;
              payload.bin_id = this.uploadDetails.binId;
              payload.is_cloud_upload = this.isCloudUpload;
              payload.is_folder_upload = true;
              if(selectedFilenames[i].webkitRelativePath){
                payload.relative_path = selectedFilenames[i].webkitRelativePath.substring(0, selectedFilenames[i].webkitRelativePath.lastIndexOf("/") + 1);
              }
              if (this.$refs.sequenceMetadataModel && this.$refs.sequenceMetadataModel.getCatalogDetails()) {
                payload.catalog_id_path = this.$refs.sequenceMetadataModel.getCatalogDetails();
              }
              //ToDo: Can be checked before getting session info
              if (this.specialCharactersToBeAvoided.exec(selectedFilenames[i].name) != null) {
                alert('File name containing any of these <>:"|/?*\\ characters are skipped');
                return;
              }
              this.createNewJob(payload).then(async (data) => {
                    if (!Utils.isAcceptedStatusCode(data.statusCode)) {
                        this.$toast.error(data.message);
                        if (this.enableBarcodeFromStartup.enable_reference_id_workflow) {
                            this.enableUpload = true;
                        }
                    }
                    const filesUploadResponse = data;
                    this.mapFileUIdWithFileData[filesUploadResponse.data.file_uid] = filesUploadResponse;
                    this.mapGroupIdWithRandomColor[filesUploadResponse.group_id] = this.generatedRandomColor;
                    if(!this.uploadedGroupsList.includes(filesUploadResponse.group_id)){
                        this.uploadedGroupsList.push(filesUploadResponse.group_id);
                    }
                    // let randomColor = this.mapGroupIdWithRandomColor[this.uploadDetails.group_id];
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        this.enableUpload = false;
                        if(this.isResumableUploadEnabled){
                            let session_payload = {
                                file_name: selectedFilenames[i].webkitRelativePath,
                                size: selectedFilenames[i].size,
                                dest_dir: this.uploadDetails.upload_path,
                                session_id: filesUploadResponse.data.session_id,
                                job_id: filesUploadResponse.job_id
                            }
                            let fileUploadSessionRes = await this.createUploadSession(session_payload);
                            if (!Utils.isAcceptedStatusCode(fileUploadSessionRes.statusCode)) {
                                this.$toast.error(fileUploadSessionRes.message);
                            }
                            console.log("Debugging: Created upload session for file "+selectedFilenames[i].name+" with response: ", fileUploadSessionRes);
                        }
                        if (Object.keys(filesUploadResponse.data.upload_url).includes("fields")) {
                            this.isMultipartUpload = true;
                            let limitUploadToCloud = this.uploadToCloudThroughProvidedUrl(selectedFilenames[i], filesUploadResponse.data.upload_url, filesUploadResponse, this.uploadDetails, filesUploadResponse.created_datetime, payload.file_name,null, filesUploadResponse.group_id, true);
                            this.addToUploadList({ "job_id": filesUploadResponse.job_id, "uploader": limitUploadToCloud });
                            this.startUpload();
                        } else {
                            const relativePath = selectedFilenames[i].webkitRelativePath || "";
                            const relativeDir = relativePath.includes("/")
                            ? relativePath.substring(0, relativePath.lastIndexOf("/") + 1)
                            : "";
                            let uploader = this.handleFileUpload(
                                selectedFilenames[i],
                                this.uploadDetails.upload_path + "/" + relativeDir,
                                this.uploadDetails.upload_token,
                                filesUploadResponse.data.session_id,
                                filesUploadResponse.data.file_uid,
                                filesUploadResponse.job_id,
                                this.uploadDetails.upload_url + "/" + relativeDir,
                                filesUploadResponse.created_datetime,
                                payload.file_name,
                                0,
                                filesUploadResponse.group_id,
                                true
                            );
                            this.addToUploadList({ "job_id": filesUploadResponse.job_id, "uploader": uploader });
                            this.startUpload()
                        }
                    } else {
                        this.$toast.error(data.message);
                    }
                });
            }
        }
    },
    getCloudProgressInfo(file, fileUID) {
        return {
             bandwidth: { "bandwidth": 0, "unit": "KB/s" },
             uploadedPercentage: 100,
             fileUID: fileUID,
             status: "COMPLETED",
             uploaded: file.size,
             fileInfo: file,
        };
    },
    uploadToCloudThroughProvidedUrl(file,uploadFields,filesUploadDataFromResponse,uploadResponse,createdTime,fileName, previousSessionInfo = null, groupId = null, isFolderUpload = false){ 
      let uploader = new FileUploaderToCloud(file,uploadFields,uploadResponse,filesUploadDataFromResponse,createdTime,fileName,false,previousSessionInfo, groupId, isFolderUpload);
      uploader.on("progress", this.handleProgress);
      uploader.on("complete", this.handleSuccess);
      uploader.on("fail", this.handleFail);
      uploader.on("exit", this.handleExit);
      return uploader;
    },
    handleFileUpload(fileDetails,uploadUrl,uploadToken,sessionId,fileUID,jobId,uploadDirURL,createdTime,fileName, uploadedBytes = 0, groupId = null, isFolderUpload = false) {
      let uploader = new FileUploder(fileDetails, uploadUrl,uploadToken, sessionId,fileUID,jobId,uploadDirURL,createdTime,fileName, false,uploadedBytes, groupId, isFolderUpload)
      uploader.on("progress", this.handleProgress);
      uploader.on("complete", this.handleSuccess);
      uploader.on("fail", this.handleFail);
      uploader.on("exit", this.handleExit);
      return uploader;
    },
    handleExit(data){
      this.handleUploadExit(data.jobId)
      this.uploadedFilesList = Object.values(this.getAllJobs);
      this.file_name_data = Array.from(this.file_name_data).filter(file => file != data.fileInfo);
      this.startUpload();
    },
    handleProgress(data){
        this.uploadedFilesList = Object.values(this.getAllJobs);
        if(this.alreadyUploadedFilesList.length){
            this.uploadedFilesList.push(...this.alreadyUploadedFilesList);
        }
        this.uploadPercentage = data.uploadedPercentages
        this.bandWidth = data.bandwidth;
    },
    handleSuccess(data){
        this.uploadedFilesList = Object.values(this.getAllJobs);
        if(this.alreadyUploadedFilesList.length){
            this.uploadedFilesList.push(...this.alreadyUploadedFilesList);
        }
        this.completedFilesList.push(data.fileUID)
        this.completedFilesList = Utils.getUnique(this.completedFilesList)
        this.uploadPercentage = data.uploadedPercentage
    },
    handleFail(){
        this.uploadPercentage = -1
    },
    humaniseSize(bytes){
      let data = Utils.humanizeSize(bytes)
      return `${data["value"]} ${data["unit"]}`
    },
    async refreshFileInfo(fileUid){
      let payload = {};
      payload.params = { fileId: fileUid};
      let data = await this.getFileInfoFromServer(payload);
        if(data.file != null){
            this.proxyOfFilesMapper[this.selectedFile.fileUID] = data.file;
            if(this.selectedFile.file.type.split("/")[0] == "image"){
              this.selectedMediaType = "image";
              try {
                  if ("proxy_info" in data.file) {
                      if ("thumbnail_uri" in data.file.proxy_info) {
                          this.imageThumbnailUrl = Utils.convertToLoginIPDomainName(data.file.proxy_info.thumbnail_uri);
                      }else{
                          this.selectedMediaType = null;
                      }
                  } else {
                    this.selectedMediaType = null;
                  }
              } catch (err) {
                  console.error(`[getThumbnailPathfromFileInfo][Utils][Error->${err.message}]`)
              }
              if(this.imageThumbnailUrl == undefined)this.selectedMediaType = null;
        }else if (this.selectedFile.file.type.startsWith("video") && "lowres_uri" in data.file.proxy_info){
                  this.selectedMediaType = "video";
                  try{
                    if ("proxy_info" in data.file) {
                          if ("lowres_uri" in data.file.proxy_info) {
                              if(this.generatedThumbnailCount == 0){
                                this.thumbnailFromServerUrl =  Utils.convertToLoginIPDomainName(data.file.proxy_info.thumbnail_uri);
                              }
                              if(this.thumbnailFromServerUrl.length){
                                this.generatedThumbnailCount++;
                              }
                               this.videoOptions.sources = [{
                                src:data.file.proxy_info.lowres_uri,
                                type: "video/mp4"
                              }]
                              if (this.controller.player){
                                  this.controller.restartPlayer(this.videoOptions.sources[0]);
                              }
                          }else{
                            this.selectedMediaType = null;
                          }
                      } else {
                        this.selectedMediaType = null;
                      }
                  }catch(err){
                    console.log("error")
                  }          
                let storyboardList = await this.getStoryboardList( {url:data.file.proxy_info.storyboard_uri});
                if(storyboardList.length != 0){
                    // this.thumbnailFromServerUrl = `${decodeURIComponent(data.file.proxy_info.storyboard_uri)}/${decodeURIComponent(storyboardList[0]["name"])}`;
                    this.secondThumbnailFromServerUrl = `${decodeURIComponent(data.file.proxy_info.storyboard_uri)}/${decodeURIComponent(storyboardList[parseInt(storyboardList.length/2)]["name"])}`;
                }
        }else if (this.selectedFile.file.type.startsWith("audio") && "audiowaveform_uri" in data.file.proxy_info){
                  this.selectedMediaType = "audio";
                  this.audioUrl = data.file.proxy_info.audiowaveform_uri
            }
        }
    },
    displayThumbnailOfSelectedFile(selectedFileInfo){
      this.isUploadedThumbnailUrl = false;
      this.canvasImg = false;
      this.selectedFile = selectedFileInfo;
      this.generatedThumbnailCount = 0;
      if(this.selectedFile == undefined || Object.keys(selectedFileInfo).length == 0){
        if(document.getElementsByClassName("activeclass").length == 0){
          let firstFile =  document.getElementsByClassName("file-name-with-progress-bar-wrapper")[0];
          firstFile.click();
        }
      }else{
        this.activeRow = this.selectedFile.fileUID;
        this.refreshFileInfo(this.selectedFile.fileUID);
      }
      this.activeThumbnail = "thumbnailFromServer";
    },
    captureThumbnailFromVideo(){
      this.canvasImg = true;
      this.isUploadedThumbnailUrl = false; 
      this.$nextTick(() => {
          let video = document.querySelector('#video video');
          let canvas = document.getElementById('canvas');
          canvas.crossOrigin = 'anonymous';
          let wrh = Number(String(getComputedStyle(video).width).replace('px','')) / Number(String(getComputedStyle(video).height).replace('px',''));
          let newWidth = canvas.width;
          let newHeight = newWidth / wrh;
          if (newHeight > canvas.height) {
              newHeight = canvas.height;
              newWidth = newHeight * wrh;
          }
          canvas.getContext("2d").drawImage(video, 0, 0, newWidth, newHeight);
          this.selectedConvasImage = canvas.toDataURL();
          this.uploadedCustomThumbnail = "";
          this.customThumbnailUploadCheckboxAction("uploadedThumbnail",true) 
      });
      // canvas.width = video.videoWidth;
      // canvas.height = video.videoHeight;
      // canvas.crossOrigin = 'anonymous';
      // let ctx = canvas.getContext('2d');
      // ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      // document.getElementById('video').then(function(canvas) {
      // document.body.appendChild(canvas);
      // });
      // video.style.backgroundImage = "url("+canvas.toDataURL()+")";
    },
    customThumbnailUploadCheckboxAction(type){
      this.activeThumbnail = type;
      let payload = {};
      payload.file_uid= this.selectedFile.fileUID;
      if(type=="uploadedThumbnail"){
        if(this.selectedConvasImage.length){
          payload.data = {cust_thumb: this.selectedConvasImage};
        }else if(this.uploadedCustomThumbnail.length){
          payload.data = {cust_thumb: this.uploadedCustomThumbnail};
        }
        payload.data.path = this.selectedFile.path;
        this.attachUploadedOrCapturedThumbnailToFile(payload)
      }else if(type=="thumbnailFromServer"){
        payload.data = {cust_thumb: this.thumbnailFromServerUrl};
        payload.data.path = this.selectedFile.path
        this.attachSelectedThumbnailToFile(payload);
      }else if(type=="thumbnailFromServerTwo"){
        payload.data = {cust_thumb: this.secondThumbnailFromServerUrl};
        payload.data.path = this.selectedFile.path;
        this.attachSelectedThumbnailToFile(payload);
      }
    },
    attachUploadedOrCapturedThumbnailToFile(payload){
      this.attachCustomThumbnail(payload).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            this.activeThumbnail = "uploadedThumbnail"
          } else {
            this.$toast.error(data.message);
            this.isUploadedThumbnailUrl = false;
            this.canvasImg = false;
            this.selectedConvasImage = "";
            this.uploadedCustomThumbnail = "";
            this.activeThumbnail = "thumbnailFromServer";
          }
        });
    },
    attachSelectedThumbnailToFile(payload){
      this.attachCustomThumbnail(payload).then((data)=>{
      if (Utils.isAcceptedStatusCode(data.statusCode)) {
          // this.activeThumbnail = 'uploadedThumbnail'
        } else {
          this.$toast.error(data.message);
          this.selectedConvasImage = "";
          this.uploadedCustomThumbnail = "";
        }
      });
    },
    updateSelectedDepartments(value){
      this.selectedDepartments = value;
    },
    uploadThumbnail(e){
      this.selectedConvasImage = "";
      this.isUploadedThumbnailUrl = true;
      this.canvasImg = false;
      const file = e.target.files[0];
      this.encodeImgtoBase64(file);
      this.thumbnailUrl = URL.createObjectURL(file);
    },
    fileUploadJobPost(){
      let payload = {};
      if(this.uploadedFilesList.length == 0 && this.file_name_data.length == 0){
        alert("Select files to upload");
        return false;
      }
      if(this.uploadedGroupsList && this.uploadedGroupsList.length){
        let SeqMetadata = this.$refs.sequenceMetadataModel.getSequenceMetadataMap(false);
        if(!SeqMetadata){
          console.log("Metadata: Mandatory fields were missed. Hence returning.")
          return false;
        }
        if(this.parentRouteInfo.name == 'bins-browse' && this.getStartUpDataFromInCache().upload_settings[0].create_catalog_as_bin_path == false){
          if(SeqMetadata.parent_id_path.length == 0){
            alert("Please select catalog");
            return false;
          }
        }else if(this.parentRouteInfo.name != 'bins-browse'){
          if(SeqMetadata.parent_id_path.length == 0){
            alert("Please select catalog");
            return false;
          }
        }

        payload.metadata = SeqMetadata;
        if(Object.keys(this.uploadDetails).includes("parentVersionFileInfo") && this.uploadDetails.parentVersionFileInfo != undefined){
          payload.src_file_uid= this.uploadDetails.parentVersionFileInfo.file_uid;
          payload.update_version = true;
        }else{
          payload.update_version = false;
        }
        if(this.barcodeName.length > 0){
          payload.metadata['reference_id'] = this.barcodeName;
          if(!this.uploadDetails.upload_category.catalog_type || (this.uploadDetails.upload_category.catalog_type && this.uploadDetails.upload_category.catalog_type != 'photo_album'))payload.reference_id_duplicate_check_required = true;
        }else{
          if(this.enableBarcodeFromStartup.enable_reference_id_workflow && this.barcodeName.trim().length == 0){
            alert("Please add barcode");
            return false;
          }
        }

        if(this.enableBarcodeFromStartup.enable_department && this.selectedDepartments){
          payload.metadata['department_id'] = this.selectedDepartments._id;
        }else if(this.enableBarcodeFromStartup.enable_department){
          alert(this.enableBarcodeFromStartup.department_alias &&  this.enableBarcodeFromStartup.department_alias.alias_name?'Please select '+this.enableBarcodeFromStartup.department_alias.alias_name:"Please select Department");
          return false;
        }
        for(let i=0;i<this.uploadedGroupsList.length;i++){
          payload.group_id = this.uploadedGroupsList[i];
            this.attachMetadataToFile(payload).then((data)=>{
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    // this.$emit("close","upload");
                    this.closeModalCompoent()
                    this.filesList = [];
                } else {
                    this.$toast.error(data.message);
                }
            });
        }
        }else{
            this.$toast.error("Unable to upload files");
        }
    },
    encodeImgtoBase64(img) {
      var reader = new FileReader();
      reader.onloadend = () => {
        this.uploadedCustomThumbnail = reader.result;
        this.selectedConvasImage = "";
        this.customThumbnailUploadCheckboxAction("uploadedThumbnail")
      }
      reader.readAsDataURL(img);
    },
    getSelectedFileInfo(fileUid){
        let fileInfo = this.uploadedFilesList.filter((e)=>e.fileUID == fileUid);
          return fileInfo[0];
    },
    async displayProxyOfFile(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let proxyNotification = notification.message;
      if((this.selectedMediaType == null || this.activeRow == proxyNotification.file_uid) && proxyNotification.file_uid == document.getElementsByClassName("file-name-with-progress-bar-wrapper")[0].id){
                  this.selectedFile = this.getSelectedFileInfo(proxyNotification.file_uid);
                  try{
                    if ("proxy_info" in proxyNotification) {
                          this.activeRow = proxyNotification.file_uid;
                          if ("lowres_uri" in proxyNotification.proxy_info) {
                              this.selectedMediaType = "video";
                              if(this.generatedThumbnailCount == 0){
                                this.thumbnailFromServerUrl =  Utils.convertToLoginIPDomainName(proxyNotification.proxy_info.thumbnail_uri);
                              }
                              if(this.thumbnailFromServerUrl.length){
                                this.generatedThumbnailCount++;
                              }
                               this.videoOptions.sources = [{
                                src:proxyNotification.proxy_info.lowres_uri,
                                type: "video/mp4"
                              }]
                              if (this.controller.player){
                                  this.controller.restartPlayer(this.videoOptions.sources[0]);
                              }
                              if( "storyboard_uri" in proxyNotification.proxy_info){
                                let storyboardList = await this.getStoryboardList( {url:proxyNotification.proxy_info.storyboard_uri});
                                if(storyboardList.length != 0){
                                    this.secondThumbnailFromServerUrl = `${decodeURIComponent(proxyNotification.proxy_info.storyboard_uri)}/${decodeURIComponent(storyboardList[parseInt(storyboardList.length/2)]["name"])}`;
                                }
                              }
                          }else if("thumbnail_uri" in proxyNotification.proxy_info){
                             this.selectedMediaType = "image";
                             this.imageThumbnailUrl =  Utils.convertToLoginIPDomainName(proxyNotification.proxy_info.thumbnail_uri);
                          }
                      } else {
                        this.selectedMediaType = null;
                      }
                  }catch(err){
                    console.log("error")
                  }          
      }
    },
    isUserPrivEnabled(priv){
      return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv)
    },
    handleUserandGroupUpdateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let notInfo = notification.message;
      if(notInfo){
        let reloadPage = false;
        if(notification.message_type == NotifierConstants.userUpdatedNotification){
          if(notInfo._id == this.getLoggedInUserId){
           reloadPage = true;
          }
        }else if([NotifierConstants.userGroupCreatedNotification,
                  NotifierConstants.userGroupModifiedNotification,
                  NotifierConstants.userGroupRemovedNotification].includes(notification.message_type)){
                    if(notInfo.user_list && notInfo.user_list.includes(this.getLoggedInUserId)){
                      reloadPage = true;
                    }
        }
        if(reloadPage){
           setTimeout(() => {
              if(!this.isUserPrivEnabled('Upload')){
                this.closeModalCompoent()
                this.filesList = [];
              }
            }, 100)
        }
      }
    },
    updateGlobalSettingsValueFromNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
      if(Object.keys(notification.message).includes('enable_reference_id_workflow')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_reference_id_workflow')){
              this.$set(this.getStartUpDataFromInCache(),"enable_reference_id_workflow",notification.message.enable_reference_id_workflow);
          }
      } 
      if(Object.keys(notification.message).includes('enable_resumable_uploads')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_resumable_uploads')){
              this.$set(this.getStartUpDataFromInCache(),"enable_resumable_uploads",notification.message.enable_resumable_uploads);
          }
      }
      if(Object.keys(notification.message).includes('enable_folder_upload')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_folder_upload')){
              this.$set(this.getStartUpDataFromInCache(),"enable_folder_upload",notification.message.enable_folder_upload);
          }
      }
    },
    async isValidSessionExist(session_response, file) {
      if(session_response && (session_response.uploaded_bytes || session_response.session_info) && session_response.job_info)
      {
        // Check if upload_url contains fields for cloud upload
        if(Object.keys(session_response.job_info.data.upload_url).includes("fields"))
        {
          let collectChunkUploadUrl = session_response.session_info;
          let payload ={ params : { path: this.$route.query.path, object_key: collectChunkUploadUrl.object_key, upload_id: collectChunkUploadUrl.upload_id }}
          let data = await this.getCloudSessionInfoFromServer(payload);
          if(!Utils.isAcceptedStatusCode(data.statusCode)) {
            return false;
          }
          const chunkSize = Utils.getMaxChunkSizeForCloud()
          //Check if data.Parts exists and is an array
          if(data.Parts && Array.isArray(data.Parts)) {
            for (let part of data.Parts) {
                const start = (part.PartNumber - 1) * chunkSize;
                const end = Math.min(start + chunkSize, file.size);
                const blobSlice = file.slice(start, end);

                const md5 = await this.computeChunkMD5(blobSlice);
                if (md5 !== part.ETag.replace(/"/g, '')) {
                    // Chunk does not match
                    return false;
                }
            }
            session_response.previousSessionChunks = data.Parts;
          }
            
          return true;
        }
        //get checksum from server
        let serverChecksum = session_response ? session_response.md5checksum : null;
        if (serverChecksum) {
          let clientChecksum = await this.calculateMD5LargeFile(file, session_response.uploaded_bytes);
          if (clientChecksum === serverChecksum) {
            // Checksums match
            return true;
          } else {
            // Checksums do not match
            return false;
          }
        }
      }
      return false;
    },
    // Chunk-based MD5 calculation for large files
    calculateMD5LargeFile(file, maxBytes = null) {
      return new Promise((resolve, reject) => {
        const chunkSize = 1 * 1024 * 1024; // 1MB
        const totalBytesToHash = maxBytes ? Math.min(maxBytes, file.size) : file.size;
        const totalChunks = Math.ceil(totalBytesToHash / chunkSize);

        let currentChunk = 0;

        const spark = new SparkMD5.ArrayBuffer();
        const reader = new FileReader();

        reader.onload = (e) => {
          spark.append(e.target.result);
          currentChunk++;

          if (currentChunk < totalChunks) {
            loadNextChunk();
          } else {
            resolve(spark.end()); // return MD5
          }
        };

        reader.onerror = () => reject("File read error");

        function loadNextChunk() {
          const start = currentChunk * chunkSize;
          const end = Math.min(start + chunkSize, totalBytesToHash);
          reader.readAsArrayBuffer(file.slice(start, end));
        }

        loadNextChunk();
      });
    },

    computeChunkMD5(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        const spark = new SparkMD5.ArrayBuffer();

        reader.onload = (e) => {
          spark.append(e.target.result);
          resolve(spark.end());
        };

        reader.onerror = () => reject("Failed reading chunk");

        reader.readAsArrayBuffer(blob);
      });
    },
    isValidSessionExistForFolder(folder_session_response,selectedFiles){
      //Match name and size
         if(folder_session_response && folder_session_response.folder_info && folder_session_response.folder_info.files){
             let files = folder_session_response.folder_info.files;
             let matchedFilesCount = 0;
             for(let i=0; i<selectedFiles.length; i++){
                let match = files.find(file => file.file_name == selectedFiles[i].webkitRelativePath && file.size == selectedFiles[i].size);
                if(match){
                  matchedFilesCount++;
                }
             }
             if(matchedFilesCount == selectedFiles.length){
                return true;
             }
         }
         return false;
    },
    pauseFolderUpload(groupId) {
      Object.values(this.getAllJobs).forEach(job => {
        if (job.groupId === groupId) {
          job.pause();
        }
      });
    },
    resumeFolderUpload(groupId) {
      Object.values(this.getAllJobs).forEach(job => {
        if (job.groupId === groupId) {
          job.resume();
        }
      });
    },
  },
  created(){
    if(!this.isUserPrivEnabled('Upload')){
      this.closeModalCompoent()
      this.filesList = [];
    }
    // this.uploadDetails = Object.assign({},this.uploadDetails?this.uploadDetails:Object.assign({}, this.$route.params.uploadDetails?this.$route.params.uploadDetails:{}))
    let payload = {bin_id: this.$route.query.bin_id, folderInfo:{ path: this.$route.query.path}}
    this.initiateUploadBySubmittingAction(payload).then((data) => {
      if(data.status == true){
        this.uploadDetails = Object.assign({}, data.data)
        this.uploadDetails["binId"] = payload.folderInfo.path.split("share://")[1].split("/")[0];
        if(this.$route.query.catalog_id && this.$route.query.catalog_id != this.uploadDetails.upload_category._id){
          let payload = {};
          payload.params = { _id: this.$route.query.catalog_id  };
          this.getCategoryInfoFromServer(payload).then((resp) => {
            let catalogDetails = {
              _id: resp.asset._id,
              catalog_name: resp.asset.catalog_name,
              parent_id_path:resp.asset.parent_id_path,
              parent_path:resp.asset.parent_path,
              catalog_type:resp.asset.catalog_type,
              asset_state:resp.asset.asset_state,
              permissions:resp.asset.permissions,
            }
            this.uploadDetails["upload_category"] = catalogDetails;
          });
        }
        if (this.$route.query.newVersion){
          Object.assign(this.uploadDetails, {parentVersionFileInfo:{file_uid: this.$route.query.parentfileUid}})
        }
        Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
        this.addWSEventListener({eventname:"FILE_UPDATED", callback:this.displayProxyOfFile,parent:"Upload"});
        this.addWSEventListener({eventname:[NotifierConstants.userUpdatedNotification,NotifierConstants.userGroupCreatedNotification,
                                            NotifierConstants.userGroupModifiedNotification,NotifierConstants.userGroupRemovedNotification],
            callback:this.handleUserandGroupUpdateNotification,parent:"Upload"});
        this.addWSEventListener({eventname:NotifierConstants.globalSettingsUpdatedNotification, callback:this.updateGlobalSettingsValueFromNotification, parent:"Upload"}); 
        this.emptyOldFiles();
        this.uploadedFilesList = Object.values(this.getAllJobs);
        this.generatedRandomColor = Utils.getRandomColor();
        this.isLoaded = true
      }else{
        this.$toast.error(data.message);
        Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
        this.closeModalCompoent()
      }
    })
  },
  beforeDestroy(){
    this.removeWSEventListener({eventname:"FILE_UPDATED", callback:this.displayProxyOfFile,parent:"Upload"});
    this.removeWSEventListener({eventname:[NotifierConstants.userUpdatedNotification,NotifierConstants.userGroupCreatedNotification,
                                            NotifierConstants.userGroupModifiedNotification,NotifierConstants.userGroupRemovedNotification],
            callback:this.handleUserandGroupUpdateNotification,parent:"Upload"});
    this.removeWSEventListener({eventname:NotifierConstants.globalSettingsUpdatedNotification, callback:this.updateGlobalSettingsValueFromNotification, parent:"Upload"}); 
  }
};
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }

  .view-tags{
    font-size: 12px;
    height: 24px;
    display: inline-flex;
    margin:2px !important;
    border: $border-color !important;
    border-radius: 15px !important;
    min-width: 50px;
    padding: 0px !important;
    text-align: center;
    width:auto !important;
    div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
    }
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $border-color;
    .modal-body{
      background: $primary-background;
      overflow:auto;
      height:300px;
      padding: 0px 0px 0px 0px;
      display:inline-flex;
      width:100%;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

    /* width */
    ::-webkit-scrollbar {
    width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
    }

.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
    .file-size-display{
      color:$active-blue;
  }
}

.activeFile{
  color:#64a8f0;
}

.modal-header,.modal-footer{
    border: none !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}

ul{
    list-style-type: none;
}
.modal-header .close {
    margin: 0px !important;
    padding: 0px !important;
}

.primary-btn-style{
    margin-top:1%;
    height:70px;
    display:inline-flex !important;
    flex-wrap: nowrap !important;
    button{
        height: 37px !important;
        border-radius: 5px;
        width: 70px;
    font-size:14px;
    float:inline-end;
    }
}

.search-bar-comm-style{
  height:30px;
  position:relative;
  input{
    border:$border-color;
    height: 25px;
    padding-inline-start: 3%;
  }
  svg{
    position: absolute;
    inset-inline-start:21px;
    top: 21%;
  }
}

.secondary-btn-style{
  color:$text-color;
  font-size:12px;
}

.modal-footer{
    justify-content: start;
}


input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    border: $border-color !important;
    background-color:$primary-background !important;
    height: 20px;
}
.row{
  margin:-12px !important;
  margin-inline-start:0px !important;
}
  /* appearance for checked radiobutton */
  input[type="radio"]:checked {
    background-color: $active-blue !important;
    background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
    border: $border-color !important;
  }

.view-tags{
    font-size: 12px;
    height: 24px;
    display: inline-flex;
    margin:2px !important;
    border: $border-color !important;
    border-radius: 15px !important;
    min-width: 50px;
    padding: 0px !important;
    text-align: center;
    width:auto !important;
    span{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
    }
}

.view-tags:hover{
    border: $border-color !important;
}

.activeTag{
    color: $active-blue !important;
}

.metadata-dock-ul{
    list-style-type: none;
    padding: 0px 3px;
    display:grid;
    background:$primary-background;
    li{
        display:inline-flex;
        padding:4px;
        border-radius: 4px;
        width:100% !important;
        .key-style{
            color:$dull-text-color;
            width:30%;
            text-align: start;
            font-size:14px;
            padding-inline-start: 5px;
            padding-inline-end: 5px;
            margin-top:3px;
        }
        .value-style{
            color: $text-color;
            width: 99%;
            text-align: start;
            padding-top: 3px;
            padding-bottom: 3px;
            padding-inline-end: 5px;
            .slug-ellipsis{
                white-space: nowrap;
                max-width: 350px;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}
.input-fields{
    border: $border-color !important;
    border-radius: 5px !important;
    margin-inline-start:5px;
    margin-bottom: 7px;
    height:40px;
}

.input-fields:focus{
    outline: unset;
}

.upload-fields {
  display: inline-block;
  padding: 7px;
  border-radius: 4px;
  margin: 4px 0px;
  width: 100%;
  position: relative;
  border: 1px solid #2b2b2b !important;
}

.progress{
  width:85%;
  border: 1px solid #2d2d2d;
  background: #222222;
}

.progress-percentage{
  position: relative;
  bottom: 2px;
  inset-inline-start:3px;
}

.progress-speed{
    position: relative;
    inset-inline-start:2%;
    bottom: 2px;
    color: #666;
    width:100px;
}

.tags-display-ul .show-tags-delete{
  visibility:hidden;
}

.tags-display-ul li:hover .show-tags-delete{
  visibility: visible;
}

.show-tags-delete{
  position: relative;
  top: 2px;
}

.secondary-btn-style:hover{
  text-decoration: underline;
}

.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}
.readonlyDiv{
    background: transparent !important;
    border: none !important;
    padding-inline-start:4px;
}
.selected-thumbnail-display{
    height: 330px;
    width: 100%;
    display: inline-block;
    border: 1px solid #2B2B2B;
    display: flex;
    justify-content: center;
    align-items: center;
    position:relative;
    div{
      flex: 0 0 120px;
    }
    img{
        height:100%;
    }
    svg{
        float: inline-end;
        margin-top:5px;
    }
}

.bigger-checkboxes {
  height: 30px;
  width: 20px;
  position: absolute;
  inset-inline-start:3px;
  top: 4px;
}

.set-thumbnail-btn{
  position:absolute;
  bottom: -25px;
  inset-inline-start:17%;
}
.set-thumbnail-btn:hover{
  text-decoration: underline;
}
.upload-progress-bar{
            height: calc(100% - 540px);
            width: 100%;
            padding-top: 7px;
            // overflow:auto;
            display:inline-block;
            position:absolute;
            .edit-upload-info{
                width:8%;
                padding: 5px;
                    svg{
                        position: relative;
                        inset-inline-end: 8px;
                    }
            }
            .file-name-with-progress-bar-wrapper{
                    display: inline-flex;
                    width: 93%;
                    padding:6px;
                    // border-bottom: 1px solid #282727;
                    .file-name-wrapper{
                        width: 90%;
                        display: inline-block;
                        .file-name-display{
                              font-size: 16px;
                              white-space: nowrap;
                              width: 98%;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              text-align: initial;
                              position: relative;
                              inset-inline-start:0px;
                              top: 2px;
                        }
                        .progress-bar-wrapper{
                                display: inline-flex;
                                width: 100%;
                                .progress-percentage-display{
                                        font-size: 11px;
                                }
                                .progress{
                                    width: 70%;
                                    background: #292929;
                                    margin-inline-start: 4px;
                                    height: 10px;
                                    margin-top: 2px;
                                    border-radius: 3px;
                                }
                                .progress-speed-display{
                                        font-size: 11px;
                                        margin-inline-start: 3px;
                                        width:64px;
                                }
                        }
                    }
                }
                .file-upload-status-display-wrapper{
                        width:10%;
                        .file-upload-status{
                            width: 30px;
                            height: 30px;
                            margin-top: 10px;
                        }
                    }
            }

.heightSet{
  overflow:auto;
    padding-top:15px;
    .thumbanils-display{
      height:143px;
      display:inline-flex;
      padding-inline-start: 8%;
      .generated-thumbails,.custom-thumbanil{
          height: 120px;
          width: 180px;
          border: 1px solid #161616;
          margin-inline-end: 10px;
          background: #110e13;
          position:relative;
          padding:3px;
        }
      .custom-thumbanil{
        position:relative;
        border: 3px dotted #1a1a1a;
      }
    }
}

.upload-status-text{
    text-align: start;
    float:inline-start;
    font-size:11px;
}

.remove-selected-file{
  visibility:hidden;
}

.file-name-with-progress-bar-wrapper:hover{
  color:$active-blue;
  .remove-selected-file{
    visibility: visible;
    position: relative;
    bottom: 2px;
  }
  .file-size-display{
    color:$active-blue;
  }
} 

.upload-files-count{
    position: sticky;
    top: -1px;
    background: $primary-background;
    z-index:9;
}

.file-size-display{
    color: #a2a0a0;
    font-size: 11px;
    width: 55px;
    font-weight: 900;
    position: relative;
    top: 1px;
}
.activeDiv{
  border:2px solid $active-blue !important;
  border-radius: 5px;
  img,canvas{
    opacity:1;
  }
}

.custom-thumbanil:hover{
  color:white;
  .replace-uploaded-thumbnail{
    border-radius: 15px;
    background: #333;
  }
}

.change-thumbnail{
    position: absolute;
    border: 1px solid #4a4949;
    inset-inline-end: 19px;
    padding: 0px 10px;
    bottom: 0px;
    background: #333;
}
.unselected-image{
  opacity:0.2;
}

.disableButton{
  pointer-events: none;
  border: 1px solid #606060 !important;
  opacity: 0.1;
  cursor: not-allowed;
}
.upload-folder-btn {
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100%;
  width: 100%;
  text-align: center;
}
</style>

